import { type CustomWorkflowSummary } from '../../store/customWorkflow/customWorkflows'

export const workflowMenuLabel = (workflow: Pick<CustomWorkflowSummary, 'name' | 'requiresUserInput'>): string =>
  workflow.requiresUserInput ? `${workflow.name}…` : workflow.name
